import React from 'react';

import { SearchReset } from '@uncinc/react-searchkit';

import './style.scss';

export interface SearchEmptyStateProps {
  title: string;
  body?: string;
  showResetButton?: boolean;
}

const SearchEmptyState: React.FC<SearchEmptyStateProps> = ({
  title,
  body,
  showResetButton = false,
}) => (
  <div className="SearchEmptyState">
    <h3 className="SearchEmptyState__title asP">{title}</h3>
    {body && <p className="SearchEmptyState__body">{body}</p>}
    {showResetButton && <SearchReset />}
  </div>
);

export default SearchEmptyState;
